import React from "react";

const LoginPageContext = React.createContext();

export default LoginPageContext;
